import { ToggleButton, Tooltip } from '@mui/material';
import { MouseEvent } from 'react';

import {
  IconGridViewMS,
  IconMapMS,
  IconTableViewMS,
  IconViewKanbanMS,
} from '../../../../constants/icons';
import { ViewMode } from '../../hooks/useViewMode';
import { StyledViewModeToggle } from './styles';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
  enabledModes?: ViewMode[];
}

interface ViewModeOption {
  value: ViewMode;
  label: string;
  icon: JSX.Element;
}

const OPTIONS: ViewModeOption[] = [
  { value: 'pipeline', label: 'Pipeline (Kanban)', icon: IconViewKanbanMS },
  { value: 'table', label: 'Tabela', icon: IconTableViewMS },
  { value: 'map', label: 'Mapa', icon: IconMapMS },
  { value: 'gallery', label: 'Galeria', icon: IconGridViewMS },
];

export function ViewModeToggle({
  viewMode,
  onChange,
  enabledModes,
}: ViewModeToggleProps): JSX.Element {
  const handleChange = (
    _event: MouseEvent<HTMLElement>,
    next: ViewMode | null
  ): void => {
    if (next && next !== viewMode) onChange(next);
  };

  return (
    <StyledViewModeToggle
      value={viewMode}
      exclusive
      size="small"
      onChange={handleChange}
      aria-label="modo de visualização"
    >
      {OPTIONS.filter(
        (option) => !enabledModes || enabledModes.includes(option.value)
      ).map((option) => (
        <Tooltip key={option.value} title={option.label} arrow>
          <ToggleButton value={option.value} aria-label={option.label}>
            {option.icon}
          </ToggleButton>
        </Tooltip>
      ))}
    </StyledViewModeToggle>
  );
}
